import React, { Component } from 'react'
import { connect } from "react-redux";
import sortBy from 'lodash/sortBy';
import { getUsers, GetRoleAction, UpdateRoleAction, getRolePermissions, removeRole } from "../../../store/actions";
import './style.scss';
import Portal from "../../../components/portal";
import AddRoleView from "./add-role";
import { ConfirmationPopUp } from "../../../components/confirmation";

import SetPermissionView from './set-permission';

class RoleView extends Component {
  state = {
    loading: false,
    rowData: "",
    isShow: false,
    showSetPermission: false,
    title: "Add Role",
    roleList: [],
    idx: null,
    isUpdate: false,
    message: {},
    isDelete: false,
    confirmationBox: false,
  };

  async componentDidMount() {
    await this.getRolesAndPermissions();
  };

  async componentDidUpdate(prev, prevState) {
    if (this.state.isUpdate || this.state.isDelete) {
      await this.getRolesAndPermissions();
    };
    /*   if (this.state.isDelete) {
        await this.getRolesAndPermissions("componentDidUpdate - isDelete");
        //this.setState({ isDelete: false, confirmationBox: false, })
      } */
  }

  getRolesAndPermissions = async () => {
    let user = this.props.UserReducer;
    await this.props.GetRoleAction(user.company);
    let roleList = await Promise.all(this.props.RoleListReducer.map(async role => {
      await this.props.getRolePermissions(role._id);
      role.permissionList = this.props.GET_ROLE_PERMISSIONS;
      return role;
    }));
    roleList = sortBy(roleList, "role")
    this.setState({ roleList, isUpdate: false, isDelete: false, confirmationBox: false });
  }

  openPopup = (event) => {
    this.setState({
      title: "Add Role",
      rowData: null,
      showRolePopup: true,
      showSetPermission: false
    });
  };

  toggleConfirmationPopup = () => {
    this.setState({ confirmationBox: false })
  }

  confirmationPopupOpen = (el) => {

    this.setState({ confirmationBox: true, id: el._id })
  }

  deleteRole = async () => {

    let result = await removeRole(this.state.id);
    if (result !== undefined) {
      this.setState({
        isDelete: true,
      })
    };
    this.toggleConfirmationPopup();
  };

  setPermission = (el, event) => {
    event.stopPropagation();
    this.setState({
      rowData: el,
      showSetPermission: true,
    });
  }

  closePermissionView = () => {
    this.setState({
      showSetPermission: false
    });
  }

  toggleClose = () => {
    this.setState({
      showRolePopup: false
    });
  };

  editRole = (el, index) => {
    this.setState({
      title: "Edit Role",
      rowData: el,
      idx: index,
      showSetPermission: false,
      showRolePopup: true
    });
  };


  editUpdate(isUpdate) {
    this.setState({
      isUpdate: isUpdate
    });
  };


  render() {
    return (

      <>
        <div className="table-header d-flex align-items-center justify-content-between">
          <h4 className="heading_h4"> Role </h4>
        </div>

        <div className="shadow_white_box full-box mt-0">
          <div className="d-flex">
            <div className="role_left">
              <div className="top_role_content">
                <p>People can have access with full control or partial control. Everyone who works on your company
                  can have a different role depending on what they need to work on.</p>
              </div>

              <div className="role_list">

                {this.state.roleList.map((el, i) => (
                  <div className="role_inner_list d-flex align-items-center justify-content-between" onClick={this.closePermissionView} key={el._id}>
                    <div className="role_name">
                      <h3>{el.role}</h3>
                      <p>{el.roleDescription}</p>
                    </div>
                    <div className="role_edit">
                      <button className="role_edit_btn" onClick={() => this.editRole(el, i)}>
                        Edit
                      </button>
                      {el.role === 'Admin' ? null : <button className="role_edit_btn" onClick={() => this.confirmationPopupOpen(el, i)}>Delete</button>}
                    </div>
                    <div className="role_set_permission" onClick={(event) => this.setPermission(el, event)} >
                      <p className="clr_blu">Set Permission</p>
                    </div>
                  </div>

                ))}


              </div>

              <div className="add_more_role" onClick={() => this.openPopup()}>
                <p className="clr_blu">+ Add new role</p>
              </div>

            </div>
            {
              this.state.showSetPermission && (<SetPermissionView rowData={this.state.rowData} action={this.props} editUpdate={this.editUpdate}></SetPermissionView>)
            }

          </div>
          {this.state.showRolePopup && (
            <Portal
              zIndex="101"
              height="380px"
              width="380px"
              close={this.toggleClose}
              title={this.state.title} >
              <AddRoleView
                roleItem={this.state.rowData}
                close={this.toggleClose}
                action={this.props}
                editUpdate={this.editUpdate}
              ></AddRoleView>
            </Portal>
          )}

          {this.state.confirmationBox && (
            <Portal
              zIndex="101"
              height="164px"
              width="424px"
              close={this.toggleConfirmationPopup}
              title="Confirmation">
              <ConfirmationPopUp
                message="Are you sure you want to delete this?"
                id={this.state.id}
                close={this.toggleConfirmationPopup}
                confirmation={this.deleteRole}
              >
              </ConfirmationPopUp>
            </Portal>
          )}

        </div>
      </>
    )
  }
}

const mapStateToProps = ({ UserReducer, UsersReducer, RoleReducer, RoleListReducer, PermissionReducer }) => {
  const { GET_ROLE_PERMISSIONS } = PermissionReducer;
  return { UserReducer, UsersReducer, RoleReducer, RoleListReducer, GET_ROLE_PERMISSIONS };
};
export default connect(mapStateToProps, { getUsers, GetRoleAction, UpdateRoleAction, getRolePermissions })(RoleView);